import { render, staticRenderFns } from "./order-verify.vue?vue&type=template&id=f8ee6798"
import script from "./order-verify.vue?vue&type=script&lang=js"
export * from "./order-verify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports